<template>
  <div class="box one" style="margin-top: 90px">
    <slot name="notice"></slot>
    <h2>고객 요청</h2>
    <div class="register">
      <div class="flexL">
        <p class="bold">고객명</p>
        <div>
          <p>{{ estimate.user ? estimate.user.username : "-" }}</p>
        </div>
      </div>
      <div class="flexL">
        <p class="bold">연락처</p>
        <div>
          <p>{{ requestContact }}</p>
        </div>
      </div>
      <template v-if="isProductEstimate || isComparisonEstimate">
        <div v-if="isProductEstimate" class="flexL">
          <p class="bold">상품</p>
          <div class="estimate-product-preview">
            <img v-if="estimate.productImage" :src="estimate.productImage" />
            <div>
              <p class="estimate-product-name">
                {{
                  estimate.productName ||
                  (estimate.product && estimate.product.name) ||
                  "-"
                }}
              </p>
              <p>{{ estimate.size || "-" }}</p>
            </div>
          </div>
        </div>
        <div v-else class="flexL">
          <p class="bold">견적 유형</p>
          <div>
            <p>{{ estimate.category || "웨딩밴드 비교 견적" }}</p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">예산 범위</p>
          <div>
            <p>{{ estimate.budgetRange || "-" }}</p>
          </div>
        </div>
        <div v-if="isComparisonEstimate" class="flexL">
          <p class="bold">선호 제품</p>
          <div v-if="preferredProducts.length" class="preferred-product-list">
            <figure
              v-for="product in preferredProducts"
              :key="product.id"
              class="preferred-product-list__item"
            >
              <img :src="product.imageUrl" :alt="product.name" />
            </figure>
          </div>
          <div v-else>
            <p>{{ preferredDesignText }}</p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">다이아몬드</p>
          <div>
            <p>{{ estimate.diamondType || "-" }}</p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">소재</p>
          <div>
            <p>
              {{
                isProductEstimate && !["14K", "18K"].includes(estimate.material)
                  ? "-"
                  : estimate.material || "-"
              }}
            </p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">소재 / 컬러</p>
          <div>
            <p>{{ estimate.materialColor || "-" }}</p>
          </div>
        </div>
        <div v-if="isComparisonEstimate" class="flexL">
          <p class="bold">방문 희망 지역</p>
          <div>
            <p>{{ estimate.visitRegion || "-" }}</p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">구매 예정 시기</p>
          <div>
            <p>{{ estimate.purchaseTiming || "-" }}</p>
          </div>
        </div>
        <div
          v-if="
            isComparisonEstimate && estimate.images && estimate.images.length
          "
          class="flexL"
        >
          <p class="bold">참고 이미지</p>
          <div class="request-image-list">
            <img
              v-for="(img, i) in estimate.images"
              :key="i"
              :src="img"
              alt="참고 이미지"
            />
          </div>
        </div>
        <div v-if="estimate.desiredPrice" class="flexL">
          <p class="bold">희망 금액</p>
          <div>
            <p>{{ estimate.desiredPrice || "-" }}</p>
          </div>
        </div>
        <div class="flexL" v-if="estimate.requestMemo">
          <p class="bold">추가 요청사항</p>
          <div>
            <p>{{ estimate.requestMemo }}</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flexL">
          <p class="bold">카테고리</p>
          <div>
            <p>{{ estimate.category || "-" }}</p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">소재</p>
          <div>
            <p>{{ estimate.material || "-" }}</p>
          </div>
        </div>
        <div class="flexL">
          <p class="bold">사이즈</p>
          <div>
            <p>{{ estimate.size || "-" }}</p>
          </div>
        </div>
        <div class="flexL" v-if="estimate.style">
          <p class="bold">스타일</p>
          <div>
            <p>{{ estimate.style }}</p>
          </div>
        </div>
        <div class="flexL" v-if="estimate.images && estimate.images.length">
          <p class="bold">첨부 이미지</p>
          <div class="flex" style="gap: 8px; flex-wrap: wrap">
            <img
              v-for="(img, i) in estimate.images"
              :key="i"
              :src="img"
              style="
                width: 80px;
                height: 80px;
                object-fit: cover;
                border-radius: 4px;
              "
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "EstimateRequestDetails",
  props: {
    estimate: { type: Object, required: true },
    requestContact: { type: String, required: true },
    isProductEstimate: Boolean,
    isComparisonEstimate: Boolean,
    preferredDesignText: { type: String, required: true },
    preferredProducts: { type: Array, default: () => [] },
  },
};
</script>

<style src="./EstimateRequestDetails.styles.scss" lang="scss" scoped></style>
